import React from 'react';

import { AccountCircleOutlined, ExitToAppOutlined } from '@material-ui/icons';
import { Button, Dropdown, NavDropdown } from 'react-bootstrap';

import { useLocalization } from '../contexts/LocalizationContext';
import { useAuth } from '../contexts/AuthContext';

// import styles from './Navigation.module.scss';

const NavigationUserDropdown = () => {
  const { user, selectRole, role, logout } = useAuth();
  const { localize } = useLocalization();

  const switchRole = (role) => {
    selectRole(role);
  };

  return (
    <>
      <div className='d-block d-lg-none mt-2 d-grid gap-2 px-1'>
        {user?.tenants[0]?.roles.map((r) => {
          return (
            <Button
              key={r.id}
              className={`${r.key === role ? 'active' : ''}`}
              onClick={() => switchRole(r)}>
              {localize(r?.name)}
            </Button>
          );
        })}

        {<hr className='dropdown-divider' />}
        <Button
          variant='outline-secondary'
          className='d-flex justify-content-center align-items-center'
          onClick={logout}>
          <ExitToAppOutlined />
          {localize('common.btn.logout')}
        </Button>
      </div>

      <div className='d-none d-lg-block'>
        <NavDropdown
          align='end'
          title={
            <span className='me-1'>
              <AccountCircleOutlined /> {user?.firstNames} {user?.lastName}
            </span>
          }
          id='mainnav-admin-dropdown'>
          <>
            <Dropdown.Header>{localize('common.roles')}</Dropdown.Header>
            {user?.tenants[0]?.roles.map((r) => {
              return (
                <Dropdown.Item
                  key={r.id}
                  className={`${r.key === role ? 'active' : ''}`}
                  as={'button'}
                  onClick={() => switchRole(r)}>
                  {localize(r?.name)}
                </Dropdown.Item>
              );
            })}
            {<NavDropdown.Divider />}
          </>

          <NavDropdown.Item onClick={logout} as={'button'} href='#'>
            {localize('common.btn.logout')}
          </NavDropdown.Item>
        </NavDropdown>
      </div>
    </>
  );
};

export default NavigationUserDropdown;
